import { Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { AlertService } from 'sce-core';
import { ResourceService } from 'sce-core';
import { PrinterSetupService } from 'sce-home';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'lfwms-assign-workstation-popup',
  templateUrl: './assign-workstation-popup.component.html',
  styleUrls: ['./assign-workstation-popup.component.css']
})
/* This component is used to perform the release task functionality
by selecting multiple ids from the id inspection screen. This component
will show a pop up with two dropdowns and a text field */
export class AssignWorkstationPopupComponent {

  public assignEventSubject = new Subject<any>();
  public reasonCode: any; // stores the list of reasoncodes from metadata
  public workStation: any; // stores the list of workstations from metadata
  public selectedReason: any; // stores the selected reason code
  public selectedWorkStation: any; // stores the selected workstation
  public remarks = ''; // stores the remarks entered
  public filedsToAssign: any; // has the reasoncode workstation and remarks entered by the user
  public title: string;
  public dataService: any;

  constructor(public modalService: ModalService,
      public resourceService: ResourceService,
      private printerSetupService: PrinterSetupService,
      private alertService: AlertService) {
    this.assignEventSubject = new Subject<any>();
  }

  // assigns the reason code and workstation dropdown values
  public setInitialData(reasonCode, workStation, dataService) {
    this.reasonCode = reasonCode;
    this.workStation = workStation;
    this.dataService = dataService;
    this.formKeyValuePairForWorkStation();
  }

  /* Combines the key and value pairs from the data using - */
  public formKeyValuePairForWorkStation() {
    if (this.workStation) {
      const workStationMetadata = JSON.parse(JSON.stringify(this.workStation));
      workStationMetadata.forEach((option) => {
        option.value = option.key + ' - ' + option.value;
      });
      workStationMetadata.sort((a: any, b: any) => {
        return (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0);
      });
      this.workStation = workStationMetadata;
    }
  }

  public assignWorkStation() {
    if (!this.selectedWorkStation) {
      this.alertService.clearAll().error(this.resourceService.get('msg_workstation'));
    } else if (!this.selectedReason) {
      this.alertService.clearAll().error(this.resourceService.get('msg_reasoncode'));
    } else {
      this.filedsToAssign = {
        reasonCode: this.selectedReason,
        workStation: this.selectedWorkStation,
        remarks: this.remarks,
      };
      this.assignWorkStationNotifyEvent(this.filedsToAssign);
    }
  }

  private assignWorkStationNotifyEvent(value: any) {
    this.assignEventSubject.next(value);
  }

  public assignWorkStationReceiveEvent(): Observable<any> {
    return this.assignEventSubject.asObservable();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/assign-workstation-popup/assign-workstation-popup.component.ts